import angular from 'angular';
import apronaQualityAggregateFormComponent from './formComponent';
import ngeoStatemanagerModule from 'ngeo/statemanager/module';

/**
 * @type {angular.IModule}
 */
export default angular.module('apronaQualityAggregateModule', [
  apronaQualityAggregateFormComponent.name,
  ngeoStatemanagerModule.name,
]);
